import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShareMediaComponent } from './components/share-media/share-media.component';
import { ShareMediaRouting } from './share-media.routing';

@NgModule({
	declarations: [ShareMediaComponent],
	imports: [CommonModule, ShareMediaRouting, SharedModule, MatDialogModule, MatTooltipModule]
})
export class ShareMediaModule {}
